import { IPromoSearchItemSchema } from '../../repositories/newbuilding-promos/entities/promo_search_result/PromoSearchItemSchema';
import { IPromoDetails } from '../../types/promos/promoDetails';

export const mapPromosDetails = (promo: IPromoSearchItemSchema): IPromoDetails => {
  return {
    banks: promo.promoPopup.banks,
    builders: promo.promoPopup.builders,
    newbuildingIds: promo.promoPopup.newbuildingIds,
    newbuildingListingUrlDesktop: promo.promoPopup.newbuildingListingUrlDesktop,
    newbuildingListingUrlMobile: promo.promoPopup.newbuildingListingUrlMobile,
    promoDescription: promo.promoPopup.promoDescription || null,
    promoName: promo.promoPopup.promoName,
    promoProps: promo.promoPopup.promoProps,
    providerLogo: promo.promoPopup.providerLogo,
    actionName: promo.promoPopup.actionName || null,
  };
};
